import {useSuspenseQuery} from '@tanstack/react-query';

import {api} from '@/lib/ky';

import {assetSchema} from '../utils/schemas/asset';

import {assetKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getAsset = async (id: string) => {
  const data = await api.get(`assets/${id}`).json();
  return assetSchema.parse(data);
};

export const useAsset = (id: string, config?: QueryConfig<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: assetKeys.detail(id),
    queryFn: () => getAsset(id),
  });
};
export const useAssetLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getAsset;
